import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';
import { createServiceApi, serviceTypes, combineEffectsWithProviders } from '@essent/common';
export { EnergyType } from '@essent/common';
import * as i1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';

/**
 * @ignore
 */
const API = new InjectionToken('api-supply-address');

const apiVersion = '3';
const getSupplyAddressesApi = createServiceApi('[SupplyAddressState] Get supply addresses', 'get', serviceTypes(), {
    getUrl: `/contracts-middleware/supplyaddresses/v${apiVersion}`,
    version: apiVersion,
    getParams: payload => payload
});

/* eslint-disable max-classes-per-file */
const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getSupplyAddressesApi);
/**
 * Module containing all providers.
 *
 * ### Example usage
 *
 * #### Normal
 * ```typescript
 * providers: [
 *     SupplyAddressCoreModule,
 *     ...
 * ]
 * ```
 *
 * #### Custom API
 *
 * ```typescript
 * providers: [
 *     SupplyAddressCoreModule.forRoot({
 *         api: 'https://my-api.com'
 *     }),
 *     ...
 * ]
 * ```
 */
class SupplyAddressCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('SupplyAddressCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: SupplyAddressCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: SupplyAddressCoreModule, deps: [{ token: SupplyAddressCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: SupplyAddressCoreModule, imports: [i1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: SupplyAddressCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: SupplyAddressCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [{ type: SupplyAddressCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getSupplyAddressesActions, getSupplyAddresses, getSupplyAddressesSuccess, getSupplyAddressesError, getSupplyAddressesClear } = getSupplyAddressesApi;

var RequestedContractStatus;
(function (RequestedContractStatus) {
    RequestedContractStatus["ACTIVE"] = "active";
    RequestedContractStatus["ALL"] = "all";
})(RequestedContractStatus || (RequestedContractStatus = {}));

var ContractStatus;
(function (ContractStatus) {
    ContractStatus["ACTIVE"] = "active";
    ContractStatus["FUTURE"] = "future";
    ContractStatus["PAST"] = "past";
    ContractStatus["RECENTLY_INACTIVE"] = "recently_inactive";
})(ContractStatus || (ContractStatus = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { API, ContractStatus, RequestedContractStatus, SupplyAddressCoreModule, getSupplyAddresses, getSupplyAddressesActions, getSupplyAddressesClear, getSupplyAddressesError, getSupplyAddressesSuccess };
